'use es6';

import { DRAFT_KEY_PREFIX } from '../constants/draftKeyPrefix';
import { getReplyId } from 'conversations-thread-data/common-reply/public/operators/commonReplyGetters';
export const makeCommonReplyDraftKey = commonReply => `${DRAFT_KEY_PREFIX}_${getReplyId(commonReply)}`;